import React, { useEffect, useState, useMemo } from "react";
import { Table } from "antd";
import axios from "axios";
import { folioColumns } from "../columns/folioColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn, rowMatchesSearch } from "../LedgerResponsive";

export default function FolioTable({ pan, onOpenModal, onDrillFolio, searchQuery }) {
  const [folios, setFolios] = useState([]); const [loading, setLoading] = useState(false);
  useEffect(() => { if (!pan) return; setLoading(true);
    axios.get(`${API_BASE}/get_folios.php?pan=${pan}&arn_no=${getArn()}`)
      .then((res) => setFolios(res.data && Array.isArray(res.data.folios) ? res.data.folios : []))
      .catch(() => setFolios([])).finally(() => setLoading(false));
  }, [pan]);
  const filtered = useMemo(() => folios.filter(r => rowMatchesSearch(r, searchQuery)), [folios, searchQuery]);
  return <LedgerResponsiveWrapper><Table loading={loading} columns={folioColumns(onOpenModal)} dataSource={filtered}
    rowKey="folio_number" pagination={false} bordered sticky scroll={{x:"max-content"}} tableLayout="auto"
    onRow={(record)=>({onClick:(e)=>{if(e.target.closest("button,a,[role='button']"))return;onDrillFolio?.(record);},style:{cursor:"pointer"}})} /></LedgerResponsiveWrapper>;
}
